// Copyright 2005-2011 David Caldwell <david@porkrind.org>, Jim Radford <radford@blackbean.org>. All Rights Reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              in_order_by=piles.in_order_by, in_numeric_order=piles.in_numeric_order, in_suit_order=piles.in_suit_order,
                              drag_max_given_free=piles.drag_max_given_free, up=piles.up;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON;

solitaire.flower = class extends pile_game {
    constructor(name, ui, initialize_now) {
        super();
        if (initialize_now ?? true)
            this.init_flower(name, ui);
    }

    init_flower(name, ui) {
        this.pile_game_init(name, ui);
        this.good = new Array(0);
        this.work = new Array(0);
        for (var c=1; c<=4; c++)
            this.good.push(new pile_game.generic_foundation("good"+c, this, true));
        for (var c=1; c<=this.work_piles(); c++)
            this.work.push(new (this.work_pile())("work"+c, this));
        this.reserve = new (this.reserve_pile())("reserve", this);
    }

    name = "flower";

    work_pile() {
      return class extends pile {
        accept_stacks = true;
        can_drag(index) { return in_order_by(in_numeric_order, this.pile, index)
                          && this.pile.length - index <= drag_max_given_free(this.game.work); }
        accept(cards) {
                    return this.pile.length == 0 && cards.length <= drag_max_given_free(this.game.work, this) ? 1 :
                           this.pile.length != 0 && in_suit_order(cards[0], this.top())                       ? 3 :
                           this.pile.length != 0 && in_numeric_order(cards[0], this.top())                    ? 2 : 0;
        }
        xoffset = 0;
        maxstack = Math.ceil(12.7807486631016); // Determined by query in upgrades/maxstack.sql
      };
    }

    reserve_pile() {
      return class extends pile {
        accept(card) { return false; }
        can_drag(index) { return true; }
        drag_stacks = false;
      };
    }

    work_piles() { return 6; }

    deal(deck) {
            this.reserve.pile = deck;
            for (var y=0; y<6; y++)
                for (var w in this.work) {
                    var c;
                    this.work[w].push(c = this.reserve.pop());
                    c.face = up;
                }
            for (var c=0; c<this.reserve.pile.length; c++)
                this.reserve.pile[c].face = up;
    }

    is_complete() {
            return this.good[0].pile.length == 13 && this.good[1].pile.length == 13 &&
                   this.good[2].pile.length == 13 && this.good[3].pile.length == 13 && WON;
    }

    score() {
            return this.count_cards_in(this.good);
    }

    complete() {
            return this.complete_generic(this.good, [this.work, [this.reserve]]); // add this.reserve
    }

    layout = grid(["reserve", void 0,  void 0,  "good1", "good2", "good3", "good4"],
                  [void 0,    "work1", "work2", "work3", "work4", "work5", "work6"]);
}

module.exports = solitaire.flower;
// Copyright 2005-2011 David Caldwell <david@porkrind.org>, Jim Radford <radford@blackbean.org>. All Rights Reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              in_order_by=piles.in_order_by, in_numeric_order=piles.in_numeric_order, in_suit_order=piles.in_suit_order,
                              drag_max_given_free=piles.drag_max_given_free, up=piles.up;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON;

solitaire.flower = class extends pile_game {
    constructor(name, ui, initialize_now) {
        super();
        if (initialize_now ?? true)
            this.init_flower(name, ui);
    }

    init_flower(name, ui) {
        this.pile_game_init(name, ui);
        this.good = new Array(0);
        this.work = new Array(0);
        for (var c=1; c<=4; c++)
            this.good.push(new pile_game.generic_foundation("good"+c, this, true));
        for (var c=1; c<=this.work_piles(); c++)
            this.work.push(new (this.work_pile())("work"+c, this));
        this.reserve = new (this.reserve_pile())("reserve", this);
    }

    name = "flower";

    work_pile() {
      return class extends pile {
        accept_stacks = true;
        can_drag(index) { return in_order_by(in_numeric_order, this.pile, index)
                          && this.pile.length - index <= drag_max_given_free(this.game.work); }
        accept(cards) {
                    return this.pile.length == 0 && cards.length <= drag_max_given_free(this.game.work, this) ? 1 :
                           this.pile.length != 0 && in_suit_order(cards[0], this.top())                       ? 3 :
                           this.pile.length != 0 && in_numeric_order(cards[0], this.top())                    ? 2 : 0;
        }
        xoffset = 0;
        maxstack = Math.ceil(12.7807486631016); // Determined by query in upgrades/maxstack.sql
      };
    }

    reserve_pile() {
      return class extends pile {
        accept(card) { return false; }
        can_drag(index) { return true; }
        drag_stacks = false;
      };
    }

    work_piles() { return 6; }

    deal(deck) {
            this.reserve.pile = deck;
            for (var y=0; y<6; y++)
                for (var w in this.work) {
                    var c;
                    this.work[w].push(c = this.reserve.pop());
                    c.face = up;
                }
            for (var c=0; c<this.reserve.pile.length; c++)
                this.reserve.pile[c].face = up;
    }

    is_complete() {
            return this.good[0].pile.length == 13 && this.good[1].pile.length == 13 &&
                   this.good[2].pile.length == 13 && this.good[3].pile.length == 13 && WON;
    }

    score() {
            return this.count_cards_in(this.good);
    }

    complete() {
            return this.complete_generic(this.good, [this.work, [this.reserve]]); // add this.reserve
    }

    layout = grid(["reserve", void 0,  void 0,  "good1", "good2", "good3", "good4"],
                  [void 0,    "work1", "work2", "work3", "work4", "work5", "work6"]);
}

module.exports = solitaire.flower;
